<template>
  <div class="auth-layout row align-content--center">
    <div class="flex xs12 pa-3 login-page-int">
      <div class="flex-center">
          <img
            height="70"
            src="@/assets/images/NuevoLogoIbero.png"
            class="custom-logo"
            alt="Corporación Universitaria Iberoamericana"
            itemprop="logo"
          />
      </div>
      <div class="d-flex justify--center">
        <va-card class="auth-layout__card">
          <div class="pa-3">
            <router-view />
          </div>
        </va-card>
      </div>
          <div class="text-center login-footer">
          <p>
            Copyright © {{(new Date).getFullYear()}}. Todos los derechos reservados.<br>
            <a href="https://www.ibero.edu.co/">Corporación Universitaria Iberoamericana</a>
          </p>
        </div>
    </div>
  </div>
</template>

<script>
const tabs = ['login', 'signup']

export default {
  name: 'AuthLayout',
  components: {},
  data () {
    return {
      selectedTabIndex: 0,
      tabTitles: ['login', 'createNewAccount'],
    }
  },
  computed: {
    tabIndex: {
      set (tabIndex) {
        this.$router.push({ name: tabs[tabIndex] })
      },
      get () {
        return tabs.indexOf(this.$route.name)
      },
    },
  },
}
</script>

<style lang="scss">
.auth-layout {
  min-height: 100vh;
  background-color: #fff;

  &__card {
    width: 100%;
    max-width: 600px;
  }

  &__options {
    @include media-breakpoint-down(xs) {
      flex-direction: column;
    }
  }
}

.login-page-int {
  background-color: #ffffff !important;
  border-radius: 5px 5px 5px 5px;
  -moz-border-radius: 5px 5px 5px 5px;
  -webkit-border-radius: 5px 5px 5px 5px;
  border: 1px solid #222;
  margin-left: 25%;
  margin-right: 25%;
}

.va-card {
    box-shadow: 0 2px 3px 0 #ffffff !important;
}

.login-footer a{
  color: #dfc14e !important;
}

</style>
